import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';


export type IButtonIcon = 'arrow_left' | 'arrow_right';
export type IButtonIconPos = 'left' | 'right';


const StyledIcon = styled.span<{ iconPos: IButtonIconPos }>`
  display: inline-block;
  height: 1em;
  position: relative;
  top: -0.06em; // font bottom padding compensation
  margin: 0 0.5em 0 0;
  line-height: 1;

  ${p => p.iconPos === 'right' ? css`
    margin: 0 0 0 0.5em;
  ` : null}

  svg {
    max-height: 100%;
    display: inline-block;
    /* transform: translateY(4%); */

    * {
      stroke: currentColor;
    }
  }
`


const ButtonIcon: React.FC<{ icon: IButtonIcon, iconPos: IButtonIconPos }> = ({ icon, iconPos }) => {

  let svg: React.ReactElement | null = null;
  if( icon === 'arrow_left' ) {
    svg = 
      <svg xmlns='http://www.w3.org/2000/svg' width='25' height='45' viewBox='0 0 25 45'>
          <path fill='none' fillRule='evenodd' stroke='#000' strokeWidth='2' d='M21.561 43L1 22 21.561 1'/>
      </svg>
  }
  else if( icon === 'arrow_right' ) {
    svg = 
      <svg xmlns='http://www.w3.org/2000/svg' width='15' height='23' viewBox='0 0 15 23'>
          <path fill='none' fillRule='evenodd' stroke='#000' strokeWidth='2' d='M3.173 1.928l8.942 9.108-8.942 9.107'/>
      </svg>
  }

  return <StyledIcon iconPos={iconPos}>{ svg }</StyledIcon>;
}

export default ButtonIcon;



// WEBPACK FOOTER //
// ./src/components/common/ButtonIcon.tsx